import React from "react";

const BannerFour = () => {
  return (
    <div>
      <h1>Ler quer dizer pensar com uma cabeça alheia, em lugar da própria.</h1>
      <h3>Arthur Schopenhauer</h3>
    </div>
  );
};

export default BannerFour;
